/* ==============================================================================================
 * SUBMIT SWITCHER COMPONENTS ON CORPORATE ACTION PAGE
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	var switcherForms = document.querySelectorAll("[data-feature=corporateActionSwitcherForm]");

	if (!switcherForms.length) {
		return;
	}

	for (var i = 0; i < switcherForms.length; i++) {
		(function (i) {
			Sushi.Events(switcherForms[i]).on("Switcher.switch", function () {
				switcherForms[i].submit();
			});
		})(i);
	}

})(Sushi || (Sushi = {}));
